import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import InputAutocomplete from '../../../InputAutocomplete/InputAutocompleteView';

class YearHomePurchaseView extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      workflowId,
      isPopulated,
      preprocessYearHomePurchase,
      nullableDesiredPurchaseYear,
      nullablePurchaseAtRetirement,
    } = this.props;

    if (!previousIsPopulated && isPopulated) {
      preprocessYearHomePurchase(
        workflowId,
        nullableDesiredPurchaseYear,
        nullablePurchaseAtRetirement,
      );
    }
  }

  render() {
    const {
      workflowId,
      branch,
      onYearHomePurchaseChanged,
      selectedYearOptionOrDefault,
      yearOptionsOrDefault,
      doNotSave,
      selectedYearOptionIsValid,
      stepValidator,
    } = this.props;
    return (
      <AdvWorkflowStep branch={branch} workflowId={workflowId}>
        <Validation
          workflowId={workflowId}
          validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.DesiredPurchaseYear`}
        />
        <h2>What year would you like to purchase the home?</h2>
        <AdvForm>
          <ul className="horizontal">
            <li>
              <InputAutocomplete
                isUnder
                isInteger
                inputmode="numeric"
                placeholder="Purchase Year"
                id="adv-purchase-year"
                placeholderClassName="adv-workflows-placeholder-large"
                className="lg text-center"
                value={selectedYearOptionOrDefault}
                options={yearOptionsOrDefault}
                onChange={onYearHomePurchaseChanged(workflowId)}
                showEmptyCustomMessage
                customEmptyMessage="Select Year"
              />
            </li>
          </ul>
        </AdvForm>

        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          validator={stepValidator(selectedYearOptionIsValid)}
          validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.DesiredPurchaseYear`}
          workflowId={workflowId}
          backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
          doNotSave={doNotSave}
        />
      </AdvWorkflowStep>
    );
  }
}

YearHomePurchaseView.defaultProps = {
  nullableDesiredPurchaseYear: null,
  nullablePurchaseAtRetirement: null,
};

YearHomePurchaseView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  onYearHomePurchaseChanged: PropTypes.func.isRequired,
  selectedYearOptionOrDefault: PropTypes.string.isRequired,
  yearOptionsOrDefault: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  isPopulated: PropTypes.bool.isRequired,
  preprocessYearHomePurchase: PropTypes.func.isRequired,
  nullableDesiredPurchaseYear: PropTypes.number,
  nullablePurchaseAtRetirement: PropTypes.bool,
  selectedYearOptionIsValid: PropTypes.bool.isRequired,
  stepValidator: PropTypes.func.isRequired,
  doNotSave: PropTypes.bool.isRequired,
};

export default YearHomePurchaseView;
